import React, { useEffect, useRef, useState, useCallback } from 'react';
import './NFT.css';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { pageAtom, myNftAtom, myNftBackAtom, isAuthAtom, nftDetailAtom } from '../../State';
import { ReactComponent as BackArrowSVG } from '../Images/buttons/backArrow.svg';
import { ReactComponent as MyAvatarIconSVG } from '../Images/buttons/myAvatarIcon.svg';
import { ReactComponent as UploadingSVG } from '../Images/buttons/uploadingButton.svg';
import { ReactComponent as SelectedSVG } from '../Images/buttons/nftSelected.svg';
import { ReactComponent as SelectedBackSVG } from '../Images/buttons/nftBackSelected.svg';
import 'react-loading-skeleton/dist/skeleton.css';
import { storage } from '../Util/Firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { getImagePath } from '../Util/utils';
import DataModel from '../Util/DataModel';
import NFTItem from './NFTItem';
import NFTMyCustomItem from './NFTMyCustomItem';
import { useTranslation } from 'react-i18next';

export default function NFTMyCustomUpload({ setNftType }) {
  //Daily系
  const callObject = useDaily();
  const localSessionID = useLocalSessionId();
  const { t } = useTranslation();

  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);

  //その他
  const [loadingState, setLoadingState] = useState(false);
  const [uploadingState, setUploadingState] = useState('myphoto');
  const [avatarsState, setAvatarsState] = useState(null);
  const [selectedArray, setSelectedArray] = useState([]); //選択中のスタイル
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);
  const inputFileRef = useRef(null);

  //初期化
  useEffect(() => {
    // if (uploadingState == 'uploading') {
    //   setTimeout(() => {
    //     setUploadingState('generating');
    //   }, 3000);
    // }
    // if (uploadingState == 'generating') {
    //   setTimeout(() => {
    //     setUploadingState('showAvatars');
    //   }, 4000);
    // }
  }, [uploadingState]);

  //NFTアイテムをタップ時
  const tapPickPhoto = async () => {
    //設定ページを閉じる
  };

  //NFTアイテムをタップ時
  const tapNextButton = async () => {
    if (selectedArray.length > 2) {
      setUploadingState('myphoto');
    }
  };

  //画像のローディング完了トリガー
  const loadCompleted = async () => {
    setLoadingState(true);
  };

  //戻るタップ
  const tapBackArrow = () => {
    //setIsShowUniqueState(false);
    if (uploadingState == 'myphoto') {
      setNftType('home');
      //setUploadingState(null);
    } else {
      setNftType('home');
    }
  };

  const tapGeneratedNFT = async (nftID) => {
    //setMyNftState('test1');
    setMyNftState(nftID);

    //ローカルストレージに保存
    localStorage.setItem('imageURL', nftID);

    //ローカルストレージに保存
    localStorage.setItem('nftID', nftID);

    //ローカルストレージに保存
    localStorage.setItem('nftWhoCanUse', 'anyone');

    //セッション内入っている場合は、セッションデータベースも更新
    if (callObject != null) {
      callObject
        .getMeetingSession()
        .then(async (session) => {
          try {
            //自分の情報をseessionに登録
            await DataModel.saveSessionToRoom(
              null, //ルームID
              session.meetingSession.id, //ルームのセッションID
              localSessionID, //ユーザーのテンポラリーユーザーID
              nftID, //顔
              null, //背景
              null,
              null,
              null,
              'anyone', //誰が使えるか
            );
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  //写真選択
  const selectPic = (e) => {
    //ステータス変更
    //setUploadingState('uploading');
    //return;

    const { files } = e.target;
    let file = files[0];

    //ファイルサイズチェック
    if (file.size > 5000000) {
      alert('File size should be less than 5MB');
    }

    //ステータス変更
    setUploadingState('uploading');

    const storageRef = ref(storage, `/mypic/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const percent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100); // update progress
        console.log(percent);
      },
      (err) => console.log(err),
      () => {
        //ステータス変更
        setUploadingState('generating');

        //URLを取得
        getDownloadURL(uploadTask.snapshot.ref).then(async (url) => {
          console.log('アップロード完了');
          console.log(url);

          //アバターを生成
          let result;
          let gender;
          try {
            result = await DataModel.getFaceData(url);
          } catch (e) {
            result = null;
          }

          console.log(result);

          //エラーの場合
          if (result == null) {
            // alert('Error');
            // setUploadingState('myphoto');
            // return;
            gender = 'm';
          } else {
            gender = result.gender ?? 'm';
          }

          if (gender == 'f') {
            setUploadingState('showAvatars');
          } else {
            let rand = Math.floor(Math.random() * 3) + 1;
            if (rand == 1) {
              setUploadingState('showAvatars2');
            } else if (rand == 2) {
              setUploadingState('showAvatars2');
            } else if (rand == 3) {
              setUploadingState('showAvatars4');
            }
          }

          // //成功の場合
          // if (result.status == 'success') {
          //   //アバター情報をセット
          //   setAvatarsState(result.patternsArray);

          //   //ステータス変更
          //   setUploadingState('showAvatars');
          // }
          // //エラーの場合はUIを戻す
          // else {
          //   alert('Error');
          //   setUploadingState('myphoto');
          // }
        });
      },
    );
  };

  return (
    <>
      <div id="nftListTitle">
        <BackArrowSVG onClick={tapBackArrow} />
        <div>
          <img
            src={getImagePath() + '/header/2dme.png'}
            style={{ width: '80px', lineHeight: '20px', paddingTop: '15px' }}
          />
        </div>
      </div>
      <div id="myAvatarWrap">
        {/* スタイル選択 */}
        {uploadingState == null && (
          <>
            <div className="myAvatarTitleWrap">
              <div className="myAvatarTitleLeft">
                <div className="myAvatarTitle">Select 6 styles</div>
                <div className="myAvatarDetail">AI makes 6 different syles of you at once</div>
              </div>
              <div className="myAvatarTitleRight">
                <button
                  className={
                    selectedArray.length > 2
                      ? 'myAvatarNextButton '
                      : 'myAvatarNextButton deactivated'
                  }
                  onClick={tapNextButton}>
                  Next
                </button>
                <div className="myAvatarCount">{selectedArray.length} / 6</div>
              </div>
            </div>
            <div className="myAvatarList">
              <NFTMyCustomItem
                baseName={'base0'}
                selectedArray={selectedArray}
                setSelectedArray={setSelectedArray}
              />
              <NFTMyCustomItem
                baseName={'base3'}
                selectedArray={selectedArray}
                setSelectedArray={setSelectedArray}
              />
              <NFTMyCustomItem
                baseName={'base4'}
                selectedArray={selectedArray}
                setSelectedArray={setSelectedArray}
              />

              <NFTMyCustomItem
                baseName={'base5'}
                selectedArray={selectedArray}
                setSelectedArray={setSelectedArray}
              />
              <NFTMyCustomItem
                baseName={'base2'}
                selectedArray={selectedArray}
                setSelectedArray={setSelectedArray}
              />

              <NFTMyCustomItem
                baseName={'base6'}
                selectedArray={selectedArray}
                setSelectedArray={setSelectedArray}
              />
            </div>
          </>
        )}

        {/* 写真選択 */}
        {uploadingState == 'myphoto' && (
          <>
            <div className="myAvatarTitleWrap">
              <div className="myAvatarTitleLeft">
                <div className="myAvatarTitle">{t('nft.Upload a photo')}</div>
                <div className="myAvatarDetail">{t('nft.AI refers the photo to generate')}</div>
              </div>
            </div>
            <div id="myAvatarPictureArea">
              <MyAvatarIconSVG />
            </div>
            <input
              ref={inputFileRef}
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={selectPic}
            />
            <button id="myAvatarButton" onClick={() => inputFileRef.current?.click()}>
              {t('nft.Pick a photo')}
            </button>
          </>
        )}

        {/* 画像をアップロード中 */}
        {uploadingState == 'uploading' && (
          <>
            <div id="myAvatarPictureArea">
              <div id="myAvatarPictureUploading">
                <UploadingSVG />
              </div>

              <div className="myAvatarUploading">{t('nft.Uploading...')}</div>
            </div>
          </>
        )}

        {/* アバター生成中 */}
        {uploadingState == 'generating' && (
          <>
            <div id="myAvatarPictureArea">
              <div id="myAvatarPictureUploading">
                <img src={getImagePath() + '/buttons/loading.webp'} />
              </div>

              <div className="myAvatarUploading">{t('nft.Generating...')}</div>
            </div>
          </>
        )}

        {/* アバターを表示 */}
        {uploadingState == 'showAvatars' && (
          <>
            <div className="myAvatarTitleWrap">
              <div className="myAvatarTitleLeft">
                <div className="myAvatarTitle" style={{ marginBottom: '20px' }}>
                  {t('nft.Generated Avatars')}
                </div>
                {/* <div className="myAvatarDetail">AI refers the photo to generate</div> */}
              </div>
            </div>
            {/* <div className="nftTitleEach">Generated Avatars </div> */}
            <div className="nftPartnerList myAvatarList myAvatarListResult">
              {avatarsState != null && (
                <>
                  {avatarsState.map((avatar, index) => (
                    <>
                      <NFTItem
                        key={index}
                        imageURL={null}
                        type="pro"
                        nftID={avatar.patternID}
                        limit="anyone"
                        showType="partnerList"
                      />
                    </>
                  ))}
                </>
              )}

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src={getImagePath() + '/styles/d1.png'}
                    onClick={() => tapGeneratedNFT('temp2')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src={getImagePath() + '/styles/d2.png'}
                    onClick={() => tapGeneratedNFT('temp1')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src={getImagePath() + '/styles/d3.png'}
                    onClick={() =>
                      tapGeneratedNFT(
                        'ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-115742538746809213209730468154594685346766595448918885480630280973518322532353',
                      )
                    }
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>
              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src={getImagePath() + '/styles/d4.png'}
                    onClick={() =>
                      tapGeneratedNFT('ethereum-0xe785e82358879f061bc3dcac6f0444462d4b5330-906')
                    }
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src={getImagePath() + '/styles/d5.png'}
                    onClick={() =>
                      tapGeneratedNFT(
                        'ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-87383727123620161737292094198014250315741856288672271608440919154410995580929',
                      )
                    }
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src={getImagePath() + '/styles/d6.png'}
                    onClick={() =>
                      tapGeneratedNFT(
                        'ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-6809306188428173666073685742513789835067604049849918034403299165762022801409',
                      )
                    }
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}

        {/* アバターを表示2 */}
        {uploadingState == 'showAvatars3' && (
          <>
            <div className="myAvatarTitleWrap">
              <div className="myAvatarTitleLeft">
                <div className="myAvatarTitle" style={{ marginBottom: '20px' }}>
                  {t('nft.Generated Avatars')}
                </div>
                {/* <div className="myAvatarDetail">AI refers the photo to generate</div> */}
              </div>
            </div>
            {/* <div className="nftTitleEach">Generated Avatars </div> */}
            <div className="nftPartnerList myAvatarList myAvatarListResult">
              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/custom5ac34c4c-ab5d-4b3e-b2f1-e1c2c01d8a0c.png"
                    onClick={() => tapGeneratedNFT('custom5ac34c4c-ab5d-4b3e-b2f1-e1c2c01d8a0c')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/custome7338986-6718-4086-b2aa-ab26562cb970.png"
                    onClick={() => tapGeneratedNFT('custome7338986-6718-4086-b2aa-ab26562cb970')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/customfcf42714-22bc-45e3-ac92-e0790d4bb25d.png"
                    onClick={() => tapGeneratedNFT('customfcf42714-22bc-45e3-ac92-e0790d4bb25d')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>
              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://d2wp3sepl8g4xv.cloudfront.net/model/images/ethereum-0x8b1ce0ab6f2b3b4e2b98f1b35ff986d9b8d481a2-1292.png"
                    onClick={() =>
                      tapGeneratedNFT('ethereum-0x8b1ce0ab6f2b3b4e2b98f1b35ff986d9b8d481a2-1292')
                    }
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://d2wp3sepl8g4xv.cloudfront.net/model/images/kobayashikiyo.png"
                    onClick={() => tapGeneratedNFT('kobayashikiyo')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://d2wp3sepl8g4xv.cloudfront.net/model/images/ethereum-0x704bf12276f5c4bc9349d0e119027ead839b081b-10189.png"
                    onClick={() =>
                      tapGeneratedNFT('ethereum-0x704bf12276f5c4bc9349d0e119027ead839b081b-10189')
                    }
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}

        {/* アバターを表示3 */}
        {uploadingState == 'showAvatars2' && (
          <>
            <div className="myAvatarTitleWrap">
              <div className="myAvatarTitleLeft">
                <div className="myAvatarTitle" style={{ marginBottom: '20px' }}>
                  {t('nft.Generated Avatars')}
                </div>
                {/* <div className="myAvatarDetail">AI refers the photo to generate</div> */}
              </div>
            </div>
            {/* <div className="nftTitleEach">Generated Avatars </div> */}
            <div className="nftPartnerList myAvatarList myAvatarListResult">
              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/customa3131c9b-fef6-4607-ace5-63f58271eb88.png"
                    onClick={() => tapGeneratedNFT('customa3131c9b-fef6-4607-ace5-63f58271eb88')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/custom86c8afcb-09b2-474c-bab9-fadf1c977e56.png"
                    onClick={() => tapGeneratedNFT('custom86c8afcb-09b2-474c-bab9-fadf1c977e56')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/custom7e859317-99aa-4410-94a7-c9ffa5037534.png"
                    onClick={() => tapGeneratedNFT('custom7e859317-99aa-4410-94a7-c9ffa5037534')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>
              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/custom9493d7e3-f55b-4d51-8ba3-613492fbfd55.png"
                    onClick={() => tapGeneratedNFT('custom9493d7e3-f55b-4d51-8ba3-613492fbfd55')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/custom18880cff-d96b-4e3b-97e3-c777cc6d53f5.png"
                    onClick={() => tapGeneratedNFT('custom18880cff-d96b-4e3b-97e3-c777cc6d53f5')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/customc55202e0-e5bb-4a75-8dc1-bd85f74eac06.png"
                    onClick={() => tapGeneratedNFT('customc55202e0-e5bb-4a75-8dc1-bd85f74eac06')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}

        {/* アバターを表示4 */}
        {uploadingState == 'showAvatars4' && (
          <>
            <div className="myAvatarTitleWrap">
              <div className="myAvatarTitleLeft">
                <div className="myAvatarTitle" style={{ marginBottom: '20px' }}>
                  {t('nft.Generated Avatars')}
                </div>
                {/* <div className="myAvatarDetail">AI refers the photo to generate</div> */}
              </div>
            </div>
            {/* <div className="nftTitleEach">Generated Avatars </div> */}
            <div className="nftPartnerList myAvatarList myAvatarListResult">
              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/customfcec5563-50ef-4c5e-9ae1-a18596fa7583.png"
                    onClick={() => tapGeneratedNFT('customfcec5563-50ef-4c5e-9ae1-a18596fa7583')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/custom996ecc4c-fdf4-4464-85c5-13745cca455f.png"
                    onClick={() => tapGeneratedNFT('custom996ecc4c-fdf4-4464-85c5-13745cca455f')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/custom20cb3fdc-ab14-4767-ac8a-a037a7658387.png"
                    onClick={() => tapGeneratedNFT('custom20cb3fdc-ab14-4767-ac8a-a037a7658387')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>
              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/custom6ad56977-25b4-4688-b3c4-679c9ea5e33d.png"
                    onClick={() => tapGeneratedNFT('custom6ad56977-25b4-4688-b3c4-679c9ea5e33d')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/customd462d2ee-7e69-4efe-a0e2-5aa48750083b.png"
                    onClick={() =>
                      tapGeneratedNFT('customd462d2ee-7e69-4efe-a0e2-5aa48750083b.png')
                    }
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>

              <div className="nftPartnerItem">
                <div className="relativeBox">
                  <img
                    src="https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/custom526376bd-8a7f-45a7-8261-373c422ec71c.png"
                    onClick={() => tapGeneratedNFT('custom526376bd-8a7f-45a7-8261-373c422ec71c')}
                    style={{
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
